import React from 'react';
import classNames from 'classnames';
import { Spinner } from 'react-bootstrap';

export const SmallSpinner = ({ className }: any) => (
  <div className={classNames(className, 'w-100 d-flex justify-content-center align-items-center my-5')}>
    <Spinner animation="border" variant="danger" />
  </div>
);
